import { gql } from '@apollo/client';
import Fragments from './fragments';

export const PAGED_CHECKLISTS_QUERY = gql`
  query pagedChecklists($pager: PagerInputNew, $filters: ChecklistsFilterInput) {
    pagedChecklists(pager: $pager, filters: $filters) {
      total
      values {
        ...checklistsItem
      }
    }
  }
  ${Fragments.checklistsItem}
`;

export const CHECKLIST_FILTERS_QUERY = gql`
  {
    checklistFilters @client {
      documentName {
        value
      }
      fullTextFilter {
        value
      }
    }
  }
`;
